import { render, staticRenderFns } from "./EDrawerMotivoAulaInfantil.vue?vue&type=template&id=3afe85b0&scoped=true"
import script from "./EDrawerMotivoAulaInfantil.vue?vue&type=script&lang=js"
export * from "./EDrawerMotivoAulaInfantil.vue?vue&type=script&lang=js"
import style0 from "./EDrawerMotivoAulaInfantil.vue?vue&type=style&index=0&id=3afe85b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afe85b0",
  null
  
)

export default component.exports